<section>

    <div class="grid grid-cols-2 gap-5">
        <div>
            <h1>{{(courseDetails$ | async)?.course_name}}</h1>
            <p class="mt-3 text-sm text-zinc-500">{{(courseDetails$ | async)?.description}}</p>

            <div *ngIf="islistaccess" class="grid grid-cols-1 md:grid-cols-2 gap-5 mt-5">
                <ng-container *ngIf="coursePrice$ | async as prices">
                    <ng-container *ngIf="prices?.length > 0; else masterPriceTemplate">
                        <div *ngFor="let price of prices; let idx = index" class=" flex flex-col gap-3 bg-white rounded-lg border border-primary-600 p-5 border-b-[7px] border-b-primary-600">
                            <p class="text-sm bg-primary-100 text-primary-600 w-max rounded px-2 py-0.5 font-semibold">
                                {{ price.price_type === 'internal' ? 'Institute Student' : 'External Student' }}
                            </p>
                            <span class="flex items-start font-semibold">&#x20B9;.
                                <span class="text-4xl font-bold">{{ price.final_price || 0 }}</span>
                                <span class="ml-3 text-sm font-normal text-zinc-500 flex flex-col">
                                    <span class="font-semibold text-black ">{{price.discount_type == "%" ? "%" + (price.discount || price.gross_discount || 0) : "&#x20B9;" + (price.discount || price.gross_discount || 0)}} OFF</span>
                                    <span class="line-through">&#x20B9; {{ price.gross_total || 0 }}</span>
                                </span>
                            </span>
                            <span class="flex items-center gap-2 text-xs text-zinc-500"><i class="ri-check-line"></i>Yearly Subscription</span>
                        </div>
                    </ng-container>
                </ng-container>

                <ng-template #masterPriceTemplate>
                    <ng-container *ngIf="courseDetails$ | async as details">
                        <ng-container *ngIf="details.master_course_price_detail?.price as masterPrice">
                            <div class=" flex flex-col gap-3 bg-white rounded-lg border border-primary-600 p-5 border-b-[7px] border-b-primary-600">
                                <p class="text-sm bg-primary-100 text-primary-600 w-max rounded px-2 py-0.5 font-semibold">
                                    {{ masterPrice.price_type === 'internal' ? 'Institute Student' : 'External Student' }}
                                </p>
                                <span class="flex items-start font-semibold">&#x20B9;.
                                    <span class="text-4xl font-bold">{{ masterPrice.final_price || 0 }}</span>
                                    <span class="ml-3 text-sm font-normal text-zinc-500 flex flex-col">
                                        <span class="font-semibold text-black ">{{masterPrice.discount_type == "%" ? "%" + (masterPrice.discount || 0) : "&#x20B9;" + (masterPrice.discount || 0)}} OFF</span>
                                        <span class="line-through">&#x20B9; {{ masterPrice.gross_total || 0 }}</span>
                                    </span>
                                </span>
                                <span class="flex items-center gap-2 text-xs text-zinc-500"><i class="ri-check-line"></i>Yearly Subscription</span>
                            </div>
                        </ng-container>
                    </ng-container>
                </ng-template>
            </div>

            <a *ngIf="iswatchaccess" [routerLink]="['/view/course',courseId]" class="w-full btn btn-lg btn-primary mt-5 cursor-pointer">Watch now <i class="ri-play-fill"></i></a>

        </div>
        <div *ngIf="iswatchaccess" class="flex justify-center items-center ">
            <a class="w-4/5 relative cursor-pointer" [routerLink]="['/view/course',courseId]">
                <img class="w-full h-auto aspect-auto object-contain rounded-lg " src="{{(courseDetails$ | async)?.thumbnail}}" alt="">
                <div
                    class="w-full h-full absolute top-0 left-0 bg-black rounded-lg flex justify-center items-center text-white text-5xl hover:opacity-50 opacity-0 transition-all duration-300 cursor-pointer">
                    <i class="ri-play-fill"></i>
                </div>
            </a>
            <span></span>
        </div>
    </div>

    @if ((courseDetails$ | async)?.id) {
    <div *ngIf="isdetailaccess" class="mt-10" >
        <div role="tablist" class="tabs tabs-bordered px-3 capitalize">
            @for (i of tabs; track $index) {
                <a role="tab" (click)="currentTab = i.value" class="tab hover:rounded-t-md" [ngClass]="{'tab-active': currentTab == i.value}">{{i.name}}</a>
            }
          </div>
    </div>

    <div *ngIf="isdetailaccess" class="mt-5" >

        <ng-container [ngSwitch]="currentTab">
            <app-general-section *ngSwitchCase="'general'"></app-general-section>
            <app-structure-section *ngSwitchCase="'structure'"></app-structure-section>
            <app-achivements-section *ngSwitchCase="'achivements'"></app-achivements-section>
            <app-pricing-section *ngSwitchCase="'pricing'"></app-pricing-section>
            <app-communication *ngSwitchCase="'communication'"></app-communication>
            <app-analytics-section *ngSwitchCase="'analytics'"></app-analytics-section>
        </ng-container>

    </div>
    }

</section>
